import Const, { FROM_DEVICE_WEB } from '../constants'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import axiosApiInstance from '@/interceptors'
import authHeader from './AuthHeader'
import Auth from '@/store/modules/Auth'
import { getModule } from 'vuex-module-decorators' 

const AuthModule = getModule(Auth, store)

class AcceptanceService {
  getAcceptance() {
    return axiosApiInstance.get(Const.api_url + "agreement");
  }

  getLatestVersion() {
    return axios.get(Const.api_url + "agreement/get-latest-term-policy-version");
  }

  Acceptance(params: any) {
    return axiosApiInstance.post(Const.api_url + "agreement/accept", params);
  }
}

export default new AcceptanceService();
